import type { Point, Token } from "../types";

/**
 * Painter order for movable map objects. Objects lower on the map are drawn
 * later, while ties keep ground effects below actors and canopies above them.
 */
export function propLayer(token: Token): number {
  return token.effect === "campfire" || token.effect === "volumetric-fire" || token.effect === "volume-fire" ? 0 : token.effect === "fly-swarm" || token.effect === "twirl" ? 2 : token.effect === "procedural-tree" ? 3 : 1;
}

export function propRenderOrder(token: Token): number {
  return token.position.y * 10 + propLayer(token);
}

export function comparePropRenderOrder(a: Token, b: Token): number {
  return propRenderOrder(a) - propRenderOrder(b) || a.position.x - b.position.x || a.id.localeCompare(b.id);
}

/** Pick only inside the rendered circular marker, never its transparent square canvas. */
export function pickTokenAtPoint(tokens: Token[], point: Point, minimumRadiusGrid = 0): Token | undefined {
  return tokens.filter((token) => Math.hypot(token.position.x - point.x, token.position.y - point.y) <= Math.max(minimumRadiusGrid, token.size * 0.42)).sort((a, b) => {
    const aDistance = Math.hypot(a.position.x - point.x, a.position.y - point.y);
    const bDistance = Math.hypot(b.position.x - point.x, b.position.y - point.y);
    return aDistance - bDistance || comparePropRenderOrder(b, a);
  })[0];
}
